import React from 'react';
import Center from './alignment/Center';

export const ErrorIndicator = () => {
  return <p className='text-5xl font-raleway text-red-600'>Error!</p>;
};

const ErrorPage = () => {
  return (
    <Center>
      <ErrorIndicator></ErrorIndicator>
    </Center>
  );
};

export default ErrorPage;
